import { DialogInfo } from "@microsoft/teams-js";
import { CardHelper, DeleteConfirmationCard, DeleteConfirmationCardProps } from "@teams/cards";
import { TeamsApplicationTypes } from "@teams/types";

import { startTask } from "./startTaskWrapper";
import { getAppId } from "./teamsHelpers";

export const startTaskDeleteConfirmation = (
  series: DeleteConfirmationCardProps | null,
  survey: DeleteConfirmationCardProps | null,
  title: string,
  applicationType: TeamsApplicationTypes,
  onTaskCompleted: (err: string | undefined, result: string | object | undefined) => void
) => {
  if (!series && !survey) {
    throw new Error("Unable to create DeleteConfirmationCard. Insufficient paramaters.");
  }
  const errorCard = DeleteConfirmationCard(
    series as DeleteConfirmationCardProps,
    survey as DeleteConfirmationCardProps,
    applicationType
  );
  const taskInfo: DialogInfo = {
    card: CardHelper.toJSONv12String(errorCard),
    title: title,
    completionBotId: getAppId(),
    width: 600,
  };
  startTask(taskInfo, onTaskCompleted);
};
